module.exports = __webpack_public_path__ + "img/img (32).5fa98ab2.png";